import { Grid } from "@mui/material";
import { useFormikContext } from "formik";
import { AutocompleteDropDown, RadioInput } from "../../../../components";
import { serviceTypeOptions } from "../../../../utils";
import { paymentVoiceTypeEnum, serviceTypeEnum } from "../../../../utils/enum";
import PstnPhoneNumbers from "./PstnPhoneNumbers";
import PRIPhoneNumbers from "./PRIPhoneNumbers";
import BriPhoneNumbers from "./BRIPhoneNumbers";
import { useEffect, useState } from "react";

const ThkInputs = () => {
  const { values }: any = useFormikContext();
  const [sericeTypeOption, setServiceTypeOption] = useState<any>();

  useEffect(() => {
    if (
      values.productTypeId === paymentVoiceTypeEnum.sanal_santral ||
      values.productTypeId === paymentVoiceTypeEnum.voip
    ) {
      setServiceTypeOption([serviceTypeEnum.bri, serviceTypeEnum.pri]);
    }
  }, [values.serviceType]);
  return (
    <>
      <Grid item md={6}>
        <AutocompleteDropDown
          label="Ses Hizmeti Tipi"
          name="serviceType"
          options={serviceTypeOptions}
          optionDisabled={sericeTypeOption}
        />
      </Grid>
      {Number(values?.serviceType) === serviceTypeEnum.pstn ? (
        <Grid item md={12}>
          <Grid container spacing={3}>
            <PstnPhoneNumbers />
          </Grid>
        </Grid>
      ) : null}
      {Number(values?.serviceType) === serviceTypeEnum.pri ? (
        <>
          <PRIPhoneNumbers />
        </>
      ) : null}
      {Number(values?.serviceType) === serviceTypeEnum.bri ? (
        <>
          <BriPhoneNumbers />
        </>
      ) : null}
    </>
  );
};

export default ThkInputs;
